module.exports = __webpack_public_path__ + "img/best-pricing-p-1080.d4c720b9.png";